// Author thq
// Date 2021-04-14 13:43:11

import * as model from "@/model/em/spareparts/EmSppAttributeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppAttribute(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emSppAttribute',
        modelFilter: model.filter
    })
    .buildStore()
